import { TAB_SHOW } from '../../../../common/tabs/tabs.constants';
import { IDS } from './pnp-settings-document-category.constants';
import { deleteDocumentCategory, getDocumentCategoryDetails } from './pnp-settings-document-category.actions';
import { getSettingsDefaultCategories } from '../pnp-settings.actions';

/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpSettingsDocumentCategory = {
    /* @ngInject */
    controller: function ($ngRedux, $mdDialog, $rootScope, Notifier) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(() => ({}), {
                getDocumentCategoryDetails,
                deleteDocumentCategory,
                getSettingsDefaultCategories,
            })(this);
            this.getSettingsDefaultCategories();
        }

        this.onSelect = ({ item }) => {
            this.getDocumentCategoryDetails(item.id).then(() => {
                $ngRedux.dispatch({
                    type: TAB_SHOW,
                    id: IDS.app_policies_settings_categories_manage,
                    state: [IDS.app_policies_settings_categories_manage_details],
                    stateParams: { id: item.rmw_id }
                });
            });
        };

        this.onRemove = ({ item }) => {
            const confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .textContent('This document category will be permanently deleted.')
                .ariaLabel('Delete document category')
                .ok('Yes, Delete')
                .cancel('No');
            this.dialog = $mdDialog.show(confirm).then(() => {
                Notifier.success('Document category has been successfully deleted');
                this.deleteDocumentCategory(item.id);
            }, angular.noop);
        };

        this.onReset = (event) => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'pnpSettingsDocumentCategoryFilterForm');
        };

        this.$onDestroy = () => {
            this.unsubscribe();
            this.dialog && $mdDialog.hide(this.dialog);
        }
    },
    template: `
        <pnp-settings-document-category-grid
            on-select="$ctrl.onSelect($event)" 
            on-remove="$ctrl.onRemove($event)"
            on-reset="$ctrl.onReset($event)">
        </pnp-settings-document-category-grid>
    `
};
